<template>
    <Page :is-loading="isPageLoading" :page-code="pageCode" @reload="loadPage">
        <div class="page-body">
            <Panel>
                <span slot="title">
                    <i class="iconfont icon-doctoral-cap fs20px top2px" /> {{orderDetail.name}}
                </span>
                <div class="lh2em bottom-line">{{orderDetail.description}}</div>
                <div class="mb-1rem">
                    <Goods v-for="(goods, i) in orderDetail.goods" :goods="goods" :key="i" />
                    <StudentOrderPayment :student="orderDetail.student" :total="total" />
                </div>
            </Panel>
            <VanButton round block :disabled="paying" :type="isWxBrowser ? 'primary' : 'info'" @click="handlePayClick">
                确认付款
            </VanButton>
            <Help :link="isWxBrowser ? '/user-doc/微信交费/index.html' : '/user-doc/支付宝交费/index.html'">
                <span v-if="isWxBrowser">
                    <i class="iconfont icon-zhifubao-plane fs17px top2px" /> 支付宝交费请点击这里查看操作方法
                </span>
                <span v-else>
                    <i class="iconfont icon-weixin-plane fs17px top2px" /> 微信交费请点击这里查看操作方法
                </span>
            </Help>
        </div>
    </Page>
</template>

<script>
    import Page from '@/components/Page.vue';
    import Panel from '@/components/Panel.vue';
    import Help from '@/components/Help.vue';
    import Goods from '@/pages/fee/components/Goods.vue';
    import StudentOrderPayment from '@/pages/fee/components/StudentOrderPayment.vue';
    import PageLoading from '@/mixins/PageLoading';
    import WxPreparing from '@/mixins/WxPreparing';
    import Utils from '@/utils';

    export default {
        name: 'OrderMasterOrder',
        components: {
            Page, Panel, Help, Goods, StudentOrderPayment,
        },
        mixins: [PageLoading, WxPreparing],
        data() {
            return {
                orderDetail: {},
                paying: false,
            };
        },
        computed: {
            total() {
                return this.orderDetail.goods ? this.orderDetail.goods.map((g) => g.realPrice).reduce((a, c) => a + c, 0) : 0;
            },
        },
        async mounted() {
            await this.loadPage();
            await this.hideWxAllMenuItems();
        },
        methods: {
            async loadPageData() {
                const { orderMasterUuid, studentUuid } = this.$route.params;
                const res = await this.$api.orderMaster.orderDetails(orderMasterUuid, studentUuid);
                this.orderDetail = res.data.data;
            },
            async handlePayClick() {
                this.paying = true;
                const { orderMasterUuid, studentUuid } = this.$route.params;
                try {
                    if (this.isWxBrowser) {
                        const res = await this.$api.orderMaster.getWxpayOrder(orderMasterUuid, { studentUuid });
                        await Utils.wx.pay(res.data.data);
                    } else {
                        const res = await this.$api.orderMaster.getAlipayOrder(orderMasterUuid, { studentUuid });
                        await Utils.alipay.pay(res.data.data);
                    }

                    this.$toast.success('支付成功');
                    await Utils.delay(2000);
                    await this.$router.replace({
                        path: `/order-masters/${orderMasterUuid}/detail`,
                        query: { studentUuid },
                    });
                } catch (err) {
                    this.$toast.fail('支付已取消');
                } finally {
                    this.paying = false;
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .icon-zhifubao-plane {
        color: #00AFF0;
    }
    .icon-weixin-plane {
        color: #07C160;
    }
</style>
